import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../@theme/theme.module';
import { PublicRoutingModule } from './public-routing.module';
import { HomeComponent } from './home/home.component';
import { ActividadDetalleComponent } from './actividad-detalle/actividad-detalle.component';
import { CursoDetalleComponent } from './curso-detalle/curso-detalle.component';
import { RegistroComponent } from './registro/registro.component';
import { PublicComponent } from './public.component';
import { DeletedUserComponent } from './deleted-user/deleted-user.component'
import { ListadoActividadesHomeComponent } from '../custom_components/listado-actividades-home/listado-actividades-home.component';
import { CompraActividadAvisoComponent } from './compra-actividad-aviso/compra-actividad-aviso.component'
import { RouterModule } from '@angular/router';
import { AvisoLegalComponent } from './avisoLegal/avisoLegal.component';
import { AvisoCookiesComponent } from './avisoCookies/avisoCookies.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { AvatarModule } from 'ngx-avatar';



const PUBLIC_COMPONENTS = [
  PublicComponent
];


@NgModule({
  imports: [
    ThemeModule,
    PublicRoutingModule,
    Ng2SmartTableModule,
    AvatarModule,
    RouterModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  declarations: [
    ...PUBLIC_COMPONENTS,
    HomeComponent,
    AvisoLegalComponent,
    AvisoCookiesComponent,
    ActividadDetalleComponent,
    CursoDetalleComponent,
    RegistroComponent,
    DeletedUserComponent,
    ListadoActividadesHomeComponent,
    CompraActividadAvisoComponent
  ],
})
export class PublicModule { }
